import { Checkbox, Radio, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import CustomContainer from '../../../components/common/CustomContainer'
import SurveySelectRange from '../../../components/emails/SurveySelectRange'
import { SurveyAnswerDto, SurveyQuestionType } from '../../../services/api/sharedTypes/Email'

interface SurveyAnswersProps {
    answers: SurveyAnswerDto[]
    surveyName: string
}

const SurveyAnswers: React.FC<SurveyAnswersProps> = ({ surveyName, answers }: SurveyAnswersProps) => {
    const theme = useTheme()

    return (
        <CustomContainer bgColor={theme.palette.background.default}>
            <Typography variant='h6'>{surveyName}</Typography>
            {answers.map((answer, index) => {
                return (
                    <Stack key={index}>
                        <Typography variant='body1' my={2} color={theme.palette.grey[700]}>
                            {answer.questionText}
                        </Typography>
                        {answer.questionType === SurveyQuestionType.Integer && (
                            <SurveySelectRange selectedValue={answer.integerAnswer ?? 0} />
                        )}
                        {answer.questionType === SurveyQuestionType.Text && (
                            <Typography variant='body2'>{answer.textAnswer}</Typography>
                        )}
                        {answer.questionType === SurveyQuestionType.SingleChoice && (
                            <Stack direction='row' alignItems='center'>
                                <Radio checked={true} disabled />
                                <Typography variant='body2'>{answer.textAnswer}</Typography>
                            </Stack>
                        )}
                        {answer.questionType === SurveyQuestionType.MultipleChoices &&
                            answer.multipleChoicesAnswer.map((choice, index) => {
                                return (
                                    <Stack direction='row' alignItems='center' key={index}>
                                        <Checkbox checked={true} disabled />
                                        <Typography variant='body2'>{choice}</Typography>
                                    </Stack>
                                )
                            })}
                    </Stack>
                )
            })}
        </CustomContainer>
    )
}

export default SurveyAnswers
